import { render, staticRenderFns } from "./detay.vue?vue&type=template&id=16cc2fce"
import script from "./detay.vue?vue&type=script&lang=js"
export * from "./detay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports